<template>
  <div id="team">
    <bread :content="breadContent"></bread>
    <p class="Page-title">研究团队</p>
    <el-divider></el-divider>
    <div class="title">
      <img class="icon" src="../../assets/leading-icon.png">
      <span>主要负责人</span>
    </div>
    <div id="leader">
      <div class="man-item" @click="$router.push({name:'teamDetail',query:{id:item.Id}})" :style="{cursor:'pointer'}" v-for="(item,index) in leader" :key="index">
        <el-avatar class="headImg" :src="item.Head"></el-avatar>
        <div>
          <a class="name">{{item.Name}}</a>
          <span class="title">{{item.JobTitle}}</span>
        </div>
        <div class="detail">
          <div>
            <img src="../../assets/profession.png">
            <span>{{item.Profession}}</span>
          </div>
          <div>
            <img src="../../assets/study.png">
            <span>{{item.ResearchDirection}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="title">
      <img class="icon" src="../../assets/man.png">
      <span>团队成员</span>
    </div>
    <div id="team-member">
      <div class="man-item" v-for="(item,index) in member" :key="index">
        <div>
          <span class="name">{{item.Name}}</span>
          <span class="title">{{item.JobTitle}}</span>
        </div>
        <div class="detail">
          <div>
            <img src="../../assets/profession.png">
            <span>{{item.Profession}}</span>
          </div>
          <div>
            <img src="../../assets/study.png">
            <span>{{item.ResearchDirection}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import Api from "@/network.js";
export default {
  name: "team",
  components: {
    bread
  },
  async beforeRouteEnter(to, from, next) {
    let res = await Api.introduce.getTeam();
    next(vm => {
      vm.leader = res.Principal;
      vm.member = res.NoPrincipal;
    });
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "中心概况", routerName: "introduce" },
        { text: "研究团队", routerName: "team" }
      ],
      leader: [],
      member: []
    };
  },
  methods: {}
};
</script>
<style lang="scss">
.el-avatar > img {
  width: 100%;
  height: auto !important;
}
</style>

<style lang="scss" scoped>
#team {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
.title {
  margin-bottom: 45px;
  .icon {
    width: 32px;
    margin-right: 10px;
  }
  span {
    font-size: 24px;
    font-weight: 400;
    color: #000000;
  }
}
#leader {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.man-item {
  width: 25%;
  text-align: center;
  // margin-bottom: 40px;
  padding: 20px 0;
  transition: background .2s;
  &:hover {
    background: #f9f9f9;
  }
  .headImg {
    height: 100px;
    width: 100px;
    margin-bottom: 5px;
    border: 1px solid transparent;
  }
  img {
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }
  .detail {
    text-align: left;
    padding-left: 10%;
    span {
      font-size: 16px;
      opacity: 0.5;
    }
    div {
      display: flex;
      align-items: center;
      margin: 15px;
    }
    img {
      margin-right: 5%;
    }
  }
  .name {
    font-size: 20px;
    font-weight: 700;
    margin-right: 5%;
    position: relative;
    left: 20px;
    color: #333333;
  }
  .title {
    font-size: 14px;
    color: #333333;
    opacity: 0.5;
    position: relative;
    left: 20px;
  }
}
#team-member {
  display: flex;
  flex-wrap: wrap;
}
</style>

